import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import Stack from '@mui/material/Stack';

import { handleApiRequest, removeStorageRecord } from '../../api';
import useUserAuth from '../../hook/useUserAuth';
import useGlobalStatus from '../../hook/useGlobalStatus';

import { PRODUCT_NAME, TOKEN, SESSION_CREATE_TIME } from '../../constants/global';
import { PAGE } from '../../constants/url';
import { ERROR_AUTH, ERROR_EMPTY_ACCOUNTORPWD } from '../../constants/alertMsg';

import Loading from '../../components/loading/Loading';
import Copyright from '../../components/copyright/Copyright';

import SystemLogin from './SystemLogin';
import { LoginBg, LoginBox } from './loginStyle';

import logo from '../../assets/images/logo-word.png'


const Login = (props) => {
  const navigate = useNavigate();
  const { userAuth, setUserAuth, authStatusMsg, setAuthStatusMsg } = useUserAuth();
  const { isLoadingLoginStatus, setIsLoadingLoginStatus } = useGlobalStatus();
  const hasLogin = localStorage.getItem(SESSION_CREATE_TIME);
  const hasToken = localStorage.getItem(TOKEN);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userAuth && hasLogin && hasToken) {
      navigate(PAGE[PAGE.index].path, { replace: true });
    }
  }, [userAuth])

  const handleGoogleLogin = (id_token) => {
    setIsLoadingLoginStatus(false);
    setIsLoading(true);

    const params = `token=${id_token}`;

    handleApiRequest('googleLogin', params)
      .then(res => {
        if (res.status === 200) {
          localStorage.setItem('token', Date.now());
          localStorage.setItem('createTime', Date.now());
          const userData = {
            name: res.data.name,
            email: res.data.email
          }
          localStorage.setItem('user', JSON.stringify(userData));

          setIsLoading(false);
          setAuthStatusMsg('');
          setUserAuth({ ...res.data });

          navigate(PAGE[PAGE.index].path);

        } else if (res.status === 401) {
          removeStorageRecord();
          setUserAuth(null);
          setAuthStatusMsg(ERROR_AUTH);
          setIsLoading(false);

        } else {
          setAuthStatusMsg(`${res.status} ${res.statusText}`);
          setIsLoading(false);
        }
      })
  }

  const handleLogin = () => {
    if (userName === '' || password === '') {
      setAuthStatusMsg(ERROR_EMPTY_ACCOUNTORPWD);
      return
    };

    setIsLoading(true);

    const requestBody = new URLSearchParams({
      username: userName,
      password: password
    });

    handleApiRequest('systemLogin', requestBody)
      .then(res => {
        if (res.status === 200) {
          localStorage.setItem('token', Date.now());
          localStorage.setItem('createTime', Date.now());
          const userData = {
            name: res.data.name,
            email: res.data.email
          }
          localStorage.setItem('user', JSON.stringify(userData));

          setIsLoading(false);
          setAuthStatusMsg('');
          setUserAuth({ ...res.data.result });

          navigate(PAGE[PAGE.index].path);

        } else if (res.status === 401) {
          removeStorageRecord();
          setUserAuth(null);
          setAuthStatusMsg(ERROR_AUTH);
          setIsLoading(false);

        } else {
          setAuthStatusMsg(`${res.status} ${res.statusText}`);
          setIsLoading(false);
        }
      })
  }

  // console.log('userAuth', userAuth);

  return (
    <>
      <LoginBg variant='center-center'>
        <LoginBox sx={{ minWidth: { xs: '320px', md: '500px' } }}>
          <Stack variant='center-center' mb={3}>
            <img src={logo} alt={PRODUCT_NAME} style={{ width: '300px' }} />
          </Stack>

          <SystemLogin
            userAuth={userAuth}
            authStatusMsg={authStatusMsg}
            setUserName={setUserName}
            setPassword={setPassword}
            handleLogin={handleLogin}
            handleGoogleLogin={handleGoogleLogin}
          />

          <Copyright style={{ textAlign: 'center' }} />

        </LoginBox>
      </LoginBg>

      <Loading isLoading={isLoading} />
    </>
  )
}

export default Login;